import { Modal } from "antd"
import React from "react"
import { useTranslation } from "react-i18next"

interface ProjectWizardAbandonConfirmProps {
  open: boolean
  onOk: () => void
  onCancel: () => void
}

export function ProjectWizardAbandonConfirm({
  open,
  onOk,
  onCancel
}: ProjectWizardAbandonConfirmProps) {
  const { t } = useTranslation()

  return (
    <Modal
      centered
      open={open}
      title={t("projectWizard.abandon.title")}
      okText={t("projectWizard.abandon.ok")}
      cancelText={t("projectWizard.abandon.cancel")}
      onOk={onOk}
      onCancel={onCancel}
    >
      <p>{t("projectWizard.abandon.content")}</p>
    </Modal>
  )
}
